import { Building2, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useOrg } from "@/contexts/OrgContext";
import { useIsAdmin } from "@/hooks/useUserRole";

const OrgOverrideBanner = () => {
  const { overrideOrgName, clearOrgOverride } = useOrg();
  const { isMasterAdmin } = useIsAdmin();
  const navigate = useNavigate();

  if (!overrideOrgName) return null;

  const handleExit = () => {
    clearOrgOverride();
    navigate(isMasterAdmin ? "/master-admin" : "/association");
  };

  return (
    <div className="bg-warning/15 border-b border-warning/25 px-4 py-2 flex items-center justify-between gap-3 shrink-0">
      <div className="flex items-center gap-2 text-xs">
        <Building2 className="w-3.5 h-3.5 text-warning" />
        <span className="text-warning font-medium">Viewing as:</span>
        <span className="font-semibold text-foreground">{overrideOrgName}</span>
      </div>
      <button
        onClick={handleExit}
        className="flex items-center gap-1 text-[10px] font-medium text-warning hover:text-warning/80 transition-colors px-2 py-1 rounded-md hover:bg-warning/10"
      >
        <X className="w-3 h-3" />
        Exit
      </button>
    </div>
  );
};

export default OrgOverrideBanner;
